import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function fetchCars() {
  const { data } = await axios.get(`${API}/cars`);
  return data;
}

export async function fetchCar(handle) {
  const { data } = await axios.get(`${API}/cars/${handle}`);
  return data;
}

export async function createLead(payload) {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
}

export async function shopifyInit(payload) {
  const { data } = await axios.post(`${API}/reservations/shopify-init`, payload);
  return data;
}

export async function ghlInit(payload) {
  const { data } = await axios.post(`${API}/reservations/ghl-init`, payload);
  return data;
}

export async function getPaymentStatus(sessionId) {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
}

export async function getSocialProof() {
  const { data } = await axios.get(`${API}/social-proof`);
  return data;
}

export async function sendPresence(sessionId, carHandle) {
  const { data } = await axios.post(`${API}/presence`, { session_id: sessionId, car_handle: carHandle });
  return data;
}

export async function getPresence(carHandle, sessionId) {
  const { data } = await axios.get(`${API}/presence/${carHandle}`, { params: { session_id: sessionId } });
  return data;
}

export async function getSocialArchived() {
  const { data } = await axios.get(`${API}/social-archived`);
  return data;
}
